(() => {
  const initStickyBuy = () => {
    document.querySelectorAll('[data-romalta-sticky-buy]').forEach((bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const mainButton = document.querySelector('.product-form__submit');
      if (!mainButton) return;
      const observer = new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      }, { rootMargin: '0px 0px -80px' });
      observer.observe(mainButton);
      bar.querySelector('button')?.addEventListener('click', () => mainButton.click());
      document.addEventListener('variant:change', (event) => {
        const price = event.detail?.html?.querySelector?.('.price');
        const target = bar.querySelector('[data-sticky-price]');
        if (price && target) target.innerHTML = price.innerHTML;
      });
    });
  };

  const initShippingMeters = () => {
    document.querySelectorAll('[data-shipping-meter]').forEach((meter) => {
      const current = Number(meter.dataset.current || 0);
      const threshold = Number(meter.dataset.threshold || 0);
      if (!threshold) return;
      meter.style.setProperty('--shipping-progress', `${Math.min(100, Math.round(current / threshold * 100))}%`);
    });
  };

  const initHeaderTone = () => {
    document.querySelectorAll('.header-wrapper').forEach((header) => {
      if (header.dataset.romaltaToneReady) return;
      header.dataset.romaltaToneReady = 'true';
      let scheduled = false;
      const update = () => {
        header.classList.toggle('is-romalta-scrolled', window.scrollY > 40);
        scheduled = false;
      };
      update();
      window.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(update);
      }, { passive: true });
    });
  };

  const initScrollReveal = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = document.querySelectorAll('.romalta-section__head, .romalta-category, .romalta-editorial__visual, .romalta-story__point');
    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach((target) => {
      if (target.dataset.romaltaRevealReady) return;
      target.dataset.romaltaRevealReady = 'true';
      target.classList.add('romalta-scroll-reveal');
      observer.observe(target);
    });
  };

  const init = () => {
    initStickyBuy();
    initShippingMeters();
    initHeaderTone();
    initScrollReveal();
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
